import { render, staticRenderFns } from "./pageSideStudentDefault.vue?vue&type=template&id=6b08d11e&scoped=true&"
import script from "./pageSideStudentDefault.vue?vue&type=script&lang=js&"
export * from "./pageSideStudentDefault.vue?vue&type=script&lang=js&"
import style0 from "./pageSideStudentDefault.vue?vue&type=style&index=0&id=6b08d11e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08d11e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
